import { IProject, IUserToken } from "@/interfaces";

export const calculateIsUserMilestoneEditor = (
  projectLoading: boolean,
  project: IProject,
  { user: { id } }: IUserToken
): boolean => {
  if (projectLoading || !project?.projectRoles || !id) return false;

  const milestoneEditors = project.projectRoles
    .filter(({ isMilestoneEditor }) => isMilestoneEditor)
    .map(({ assignedUsers }) => assignedUsers)
    .flat();

  if (!milestoneEditors) return false;

  return [...new Set(milestoneEditors)].some((editor) => editor === id);
};
